import type { ReactNode } from 'react'

import { Brand } from '@/components/primitives/Brand'
import { ConversationPreview } from '@/components/primitives/ConversationPreview'
import { Icon } from '@/components/primitives/Icon'

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <main className="auth-layout">
      <section className="auth-story" aria-label="About Convo">
        <Brand />
        <div className="auth-story-content">
          <span className="hero-label">
            <Icon name="spark" size={16} />
            Your customer experience, reimagined
          </span>
          <h2>
            Every conversation.
            <br />A new <span>possibility.</span>
          </h2>
          <p>
            Bring your AI assistants, customer conversations, and team together.
            Build connections that move your business forward.
          </p>
          <ConversationPreview />
          <div className="auth-features">
            <span>
              <Icon name="bot" size={18} />
              Thoughtful AI
            </span>
            <span>
              <Icon name="team" size={18} />
              Connected teams
            </span>
            <span>
              <Icon name="chart" size={18} />
              Clear insights
            </span>
          </div>
        </div>
        <p className="auth-story-footer">
          LESS BUSYWORK. MORE HUMAN CONNECTION.
        </p>
      </section>
      <section className="auth-form-side">
        <div className="auth-mobile-brand">
          <Brand />
        </div>
        <div className="auth-form-content">
          <p className="eyebrow">YOUR NEXT CHAPTER STARTS HERE</p>
          <h1>{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          <div className="auth-form-card">{children}</div>
          {footer && <p className="auth-footer">{footer}</p>}
          <div className="auth-security">
            <Icon name="shield" size={17} />
            Your workspace. Your people. All connected.
          </div>
        </div>
        <p className="auth-bottom">Convo · Make every conversation count.</p>
      </section>
    </main>
  )
}
